<template>
	<div class="elevation-1" style="padding: 5px" v-if="config">
		<h6>Output</h6>
		<output-qualities v-model="config.qualities"></output-qualities>
	</div>
</template>

<script>
import OutputQualities from "./OutputQualities"

export default {
	props: ["value"],
	components: {
		OutputQualities
	},
	data () {
		return {
			config: this.value
		}
	},
	created: function() {
		this.$watch("config", function(newVal) {
			this.$emit("input", newVal);
		}, {deep: true})
	}
}
</script>